import { ParameterType } from '@/study-search/enums';

import { FilterOptionInformation } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';
import { SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters/server-side';

class ShortCoursesSpecialProgrammesFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.SPECIAL_PROGRAMMES,
			[new FilterOptionInformation('Executive Programmes', SpecialProgrammesFilterOptionValue.EXECUTIVE_PROGRAMMES, '', '')],
			[],
		);
	}
}

export default new ShortCoursesSpecialProgrammesFilterDefinition();
